/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any */
import * as XLSX from "xlsx";
import { jsonFileKeyMapping } from "../models/UserDataFileFormats";
import { downloadFile } from "./downloadFile";

interface UserData {
  [key: string]: string | string[] | number;
}

const UserExcelExporter = (data: string[], dataFormat: string[], isStore: boolean, isApplication: boolean) => {
  const transformationMapping: { [key: string]: string } = {
    role: "roles",
    scope: "scopes",
    application: "scopes",
    dataid: "dataids",
    store: "dataids",
  };

  const XLSXFormat = [...dataFormat, "error"].map((item: string) => {
    return transformationMapping[item] || item;
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const processedData = data.map((user: any) => {
    const userData: UserData = {};
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    const keys = Object.keys(user).reduce((user, key) => {
      user[key.toLowerCase()] = key;
      return user;
    }, {} as { [key: string]: string });

    XLSXFormat.forEach((formatKey: string) => {
      const lowerCaseKey: string = formatKey.toLowerCase();
      const dataKey: string = keys[lowerCaseKey];
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access

      let mappedKey = jsonFileKeyMapping[formatKey];

      if (isApplication && formatKey === "scopes") {
        mappedKey = "Application";
      } else if (isStore && formatKey === "dataids") {
        mappedKey = "Store";
      }

      // Handle availability and inventory from alertPermissions
      if ((formatKey === "availability" || formatKey === "inventory") && user.alertPermissions) {
        const value = user.alertPermissions[formatKey];
        userData[mappedKey] = value === true ? "Yes" : value === false ? "No" : "";
      }
      else if (dataKey !== undefined && user[dataKey] !== undefined) {
        userData[mappedKey] = Array.isArray(user[dataKey])
          ? (user[dataKey] as string[]).join(";")
          : user[dataKey];
      }
      else {
        // fallback if key missing
        userData[mappedKey] = "";
      }
    });

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (keys["error"] !== undefined && user["error"] !== undefined) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      userData[jsonFileKeyMapping["error"]] = Array.isArray(user["error"]) ? (user["error"] as string[]).join(";") : user["error"];
    }

    return userData;
  });

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(processedData);
  XLSX.utils.book_append_sheet(wb, ws, "Users");
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const wbout: string = XLSX.write(wb, { bookType: "xlsx", type: "binary" });

  const s2ab = (s: string) => {
    const buf = new ArrayBuffer(s?.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s?.length; i++) {
      view[i] = s?.charCodeAt(i) & 0xff;
    }
    return buf;
  };

  const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });
  const fileUrl = URL.createObjectURL(blob);
  downloadFile(fileUrl, "user-errors.xlsx");
};

export default UserExcelExporter;
